import React, { useEffect, useState } from 'react';
import { api, tradotto } from './api';
import { t } from './i18n';

const COLORS = { primary: '#1a4d8f', text: '#1f2937', muted: '#6b7280', border: '#e5e7eb', bg: '#f7f8fa' };

function fmtDate(d) {
  if (!d) return '';
  try { return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
  catch (e) { return ''; }
}

// "In the news" — published articles that mention this place. Renders nothing
// when there are none, so it never leaves an empty section on a place page.
export default function PlaceNews({ establishmentId }) {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    if (!establishmentId) return undefined;
    let cancelled = false;
    api.placeNews(establishmentId)
      .then((r) => { if (!cancelled) setArticles(Array.isArray(r) ? r : []); })
      .catch(() => { if (!cancelled) setArticles([]); });
    return () => { cancelled = true; };
  }, [establishmentId]);

  if (!articles.length) return null;

  return (
    <div style={{ background: 'white', padding: 24, borderRadius: 12, marginTop: 20, border: `1px solid ${COLORS.border}` }}>
      <h3 style={{ marginTop: 0, color: COLORS.primary }}>📰 {t('In the news')}</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {articles.map((a) => (
          <a key={a.id} href={`/news/${a.slug}`}
             style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: 12, alignItems: 'center' }}>
            {a.cover_image_url && (
              <img src={a.cover_image_url} alt="" style={{ width: 64, height: 64, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
            )}
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, color: COLORS.primary, fontSize: 15 }}>{tradotto(a, 'title')}</div>
              {a.excerpt && <div style={{ fontSize: 13, color: COLORS.text, lineHeight: 1.4 }}>{tradotto(a, 'excerpt')}</div>}
              <div style={{ fontSize: 12, color: COLORS.muted, marginTop: 2 }}>{fmtDate(a.published_at)}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
